import { Card } from "@/components/Shared/Card";
import { DatosAnioListTable } from "./DatosAnioListTable";
import { Separator } from "@/components/ui/separator";

export function DatosAnioListDashboard() {
	return (
		<Card>
			<h1 className="text-xl font-bold">Listado de Datos Anuales</h1>
			<Separator />
			<DatosAnioListTable />
		</Card>
	);
}
